import React, { Component } from 'react';
import scrollToElement from 'scroll-to-element';
import { Link } from 'react-router-dom';

import MainHeader, {
  HeaderText,
  Underline,
} from 'components/shared/landing/main-header';
import CustomVideo from 'components/shared/custom-video';

import styles from './styles.module.scss';
import masteryVideo from 'assets/videos/cs-deeper-learning.mp4';
import masteryPoster from 'assets/img/cs-deeper-learning-poster.png';
import engagementVideo from 'assets/videos/cs-engagement.mp4';
import engagementPoster from 'assets/img/cs-engagement-poster.png';
import CaseStudiesHeader from 'assets/img/case-studies-header.jpg';
import playIcon from 'assets/img/video-play-button.svg';
import IntegratingExplicitSELVideo from 'assets/videos/Unyted - Integrating Explicit SEL with Core Academics (short version).mp4';
import educatorPoster from 'assets/img/educator-video-poster.png';

export default class CaseStudies extends Component {
  render() {
    return (
      <div className={styles.caseStudies}>
        <MainHeader
          header={
            <HeaderText className={styles.headerText}>
              See Unyted In
              <br />
              <Underline>Real Classrooms</Underline>
            </HeaderText>
          }
          buttonText="Read about how you can benefit"
          buttonClassName="apple"
          onButtonClick={() => scrollToElement('#reviews')}
          image={CaseStudiesHeader}
        />
        <section id="reviews" className={styles.reviews}>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-12 order-2 order-lg-1 d-flex justify-content-center flex-column">
                <h5>academic &amp; sel integration</h5>
                <h2>Model Classroom</h2>
                <p>
                  Algebra students at this public middle school were engaged in
                  Unyted Math activities pegged to grade-level standards. The
                  teacher's goal was to elevate discourse while gaining
                  visibility into student understanding. At the same time, the
                  teacher integrated a{' '}
                  <Link to="/sel-encyclopedia">targeted SEL skill</Link> that
                  would help the students learn faster and connect to the real
                  world.
                </p>
                <p>
                  A key differentiator for teachers using Unyted is the use of
                  the <Link to="/the-team-method">Team Method&trade;</Link>.
                  This method keeps the students connected throughout the
                  process of problem solving, while organically helping the
                  students practice and develop real world SEL skills.
                </p>
              </div>
              <div className="col-lg-6 col-12 order-1 order-lg-2 d-flex align-items-center">
                <CustomVideo
                  src={IntegratingExplicitSELVideo}
                  poster={educatorPoster}
                  icon={playIcon}
                />
              </div>
            </div>
          </div>
        </section>

        <section id="bell-ringers" className={styles.bellRingers}>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-12 d-flex align-items-center">
                <CustomVideo
                  src={engagementVideo}
                  poster={engagementPoster}
                  icon={playIcon}
                />
              </div>
              <div className="col-lg-6 col-12">
                <h5>Engagement &amp; fun</h5>
                <h2>Bell Ringers</h2>
                <p>
                  Middle School students at this public school were placed into
                  a competition setting. The activity was aligned to grade-level
                  standards. The teacher's goal was to engage{' '}
                  <strong>every</strong> student and create excitement despite a
                  difficult Math topic. The teacher intended to use Unyted
                  technology to spark reasoning and problem-solving with a focus
                  on student-centeredness.
                </p>
                <p>
                  The cognitive work was pushed out to the students who, as
                  seen, need to coordinate with each other to problem solve and
                  move forward. The technology, which transforms learning into
                  lessons that function like escape room games, scores students
                  according to top score in the room. Watch the excitement in
                  a...Math class! Please contact Unyted for more details and
                  methodology of this specific case.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="sel-coaching" className={styles.coaching}>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-12 order-2 order-lg-1 d-flex justify-content-center flex-column">
                <h5>Lesson Reviews</h5>
                <h2>Student Discourse</h2>
                <p>
                  4th grade students at this Elementary public school were
                  engaged in Unyted Math activities pegged to grade-level
                  standards. The teacher's goal was conceptual understanding and
                  students showing procedural skill and fluency via their verbal
                  and written explanations.
                  <br />
                  <br />
                  In typical collaborative work, one student might take over,
                  but here the students are interdependent - the technology
                  guiding them before they can move forward. The conditions are
                  created for student conversation, debate and display of depth
                  of knowledge. You even get to audibly here an 'AHA' ('Oh,
                  that's right!") moment! Please contact Unyted for more details
                  and methodology of this specific case.
                </p>
              </div>
              <div className="col-lg-6 col-12 order-1 order-lg-2 d-flex align-items-center">
                <CustomVideo
                  src={masteryVideo}
                  poster={masteryPoster}
                  icon={playIcon}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
